const zh = {
  title1: '区块链诈骗概述',
  article1: '一些不法分子打着“区块链”的名义或利用“区块链”技术，通过高收益理财、钓鱼、假App、合约后门、骗取授权等方式进行诈骗，是以区块链之名行传销、诈骗之实的违法行为。',
  title2: 'TokenPocket反诈介绍',
  article2: 'TokenPocket 致力于区块链反诈骗、防诈骗的宣传和教育，建立诈骗域名举报渠道，致力于构建良好的区块链网络环境。',
  title3: '常见的诈骗方式',
  title4: '常见诈骗案例',
  title5: '安全措施及防范',
  title6: '更多资讯',
  share: '分享给朋友',
  copied: '复制成功',
  list1: [{
    title: '假钱包',
    subtitle: '不要使用他人给发送的钱包链接或APK安装包。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/verification',
    pic: require('../../assets/1.png')
  }, {
    title: '私钥助记词钓鱼',
    subtitle: '不要把私钥泄露给任何人。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/swindle',
    pic: require('../../assets/2.png')
  }, {
    title: '恶意授权',
    subtitle: '恶意授权是通过利用EVM链上常用的一个Approve操作函数来实现的。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/approve1',
    pic: require('../../assets/3.png')
  }, {
    title: '合约调用转账',
    subtitle: '合约调用转账盗币是一种新型的盗币方式，它的隐蔽性更强。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/call',
    pic: require('../../assets/4.png')
  }],
  list2: [{
    title: '波场钓鱼钱包',
    subtitle: '一种骗取Gas（矿工费）的骗局。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/tron',
    pic: require('../../assets/5.png')
  }, {
    title: '恶意授权',
    subtitle: '恶意授权过的地址不要继续操作USDT的资产转入，您可以使用工具清理授权记录后继续使用，或者新建一个钱包地址来使用（推荐）。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/approve',
    pic: require('../../assets/6.png')
  }, {
    title: '新型盗币方式',
    subtitle: '在钱包中切记不要访问不明来路的链接（私钥、助记词钓鱼等），也不要访问不安全的空投网站，以防Approve钓鱼陷阱；',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/xinzhapian',
    pic: require('../../assets/7.png')
  }, {
    title: '几类常见的区块链骗局',
    subtitle: '快速识别区块链中的骗局。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/kuai-su-shi-bie-ou-kuai-lian-zhong-de-pian-ju',
    pic: require('../../assets/8.png')
  }],
  list3: [{
    title: '一文学会分辨TP钱包是否正版',
    subtitle: '新人必读。',
    url: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/Testing',
    pic: require('../../assets/9.png')
  }, {
    title: '授权（Approve）一文详解！',
    subtitle: '遇到授权（Approve）的时候，一定要多加小心！',
    url: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/about-approve',
    pic: require('../../assets/12.png')
  }, {
    title: '如何查看/取消恶意Approve（授权）？',
    subtitle: '授权（Approve）理论和实践相结合。',
    url: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/cancel-malicious-authorization',
    pic: require('../../assets/13.png')
  }, {
    title: '使用Cointool管理授权记录',
    subtitle: '授权管理操作教程。',
    url: 'https://theodore-ratliff.gitbook.io/share/CN/security/cointool',
    pic: require('../../assets/14.png')
  }, {
    title: '资产防丢',
    subtitle: '做好资产防丢最重要的就是做好钱包备份并妥善保管。',
    url: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/assests-loss-prevention',
    pic: require('../../assets/15.png')
  }, {
    title: '资产防盗',
    subtitle: '您需要保护好私钥、助记词等安全信息并遵守几个原则。',
    url: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/assets-theft-prevention',
    pic: require('../../assets/16.png')
  }],
  moreList: [{
    title: '保护你的钱包！假钱包全景追踪 >',
    url: 'https://mp.weixin.qq.com/s/7g6BGpwxZsr5fP3Wo1Dz_Q'
  }, {
    title: '区块链世界中的骗局及套路 >',
    url: 'https://www.panewslab.com/zh/articledetails/N3880736.html'
  }],
  warning: '区块链科普专题所有文章都不能作为投资建议或推荐，投资有风险，投资应该考虑个人风险承受能力，建议对项目进行深入考察，慎重做好自己的投资决策。不代表TokenPocket的投资建议。投资有风险，您须充分认识风险，并自行作出投资决策。'
};

export default zh;
